"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
function Spinner() {
    return (React.createElement("div", { className: "spinner" },
        React.createElement("div", { className: "dot-1" }),
        React.createElement("div", { className: "dot-2" }),
        React.createElement("div", { className: "dot-3" })));
}
exports.Spinner = Spinner;



// WEBPACK FOOTER //
// ./~/@dialogexe/cw-component-culture-program/Spinner.tsx